import React, { createContext, useContext } from "react";
import PropTypes from "prop-types";
import { useProgramData } from "../hooks/useProgramData";

const ProgramDataContext = createContext();

export const ProgramDataProvider = ({ children }) => {
  const programData = useProgramData();

  return (
    <ProgramDataContext.Provider value={programData}>
      {children}
    </ProgramDataContext.Provider>
  );
};

ProgramDataProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useProgramDataContext = () => {
  const context = useContext(ProgramDataContext);
  if (!context) {
    throw new Error(
      "useProgramDataContext must be used within a ProgramDataProvider",
    );
  }
  return context;
};
